module.exports = __webpack_public_path__ + "img/shutterstock_53252755@2x.74c645b8.png";